import React, { PropTypes } from 'react';
import classNames from  'classnames';


/**
 * User avatar.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */

const Avatar = ({ user, onClick, extraClasses = '', id }) => {
  var classes = 'avatar';

  let content = null;

  if (user && user.avatar) {
    content = <img src={user.avatar} alt="User Avatar" />;
  } else if (user && user.first_name && user.last_name) {
    content = <span>{user.first_name[0]}{user.last_name[0]}</span>;
    classes += ' avatar-text';
  } else if (user && user.username) {
    content = <span>{user.username.slice(0, 2)}</span>;
    classes += ' avatar-text';
  } else {
    /* this should not happen, but just as a safeguard */
    content = <span>-</span>;
    classes += ' avatar-text';
  }

  return (
    <div className={classNames(classes, extraClasses)} onClick={onClick} id={id}>
      { content }
    </div>
  );
};

/**
 * PropTypes.
 *
 * @property {object} user - avatar owner
 * @property {func} onClick - onClick callback
 * @property {string} extraClasses - extra CSS classes
 *
 */
Avatar.propTypes = {
  user: PropTypes.object,
  onClick: PropTypes.func,
  extraClasses: PropTypes.string,
  id: PropTypes.string,
};

export default Avatar;



// WEBPACK FOOTER //
// ./common/components/avatar.jsx